/* eslint-disable max-len */
import React from 'react';
import IconInterface from './IconInterface';

function IconHelp({ width = 12, height = 12 }: IconInterface) {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM6 0.75C3.10051 0.75 0.75 3.10051 0.75 6C0.75 8.8995 3.10051 11.25 6 11.25C8.8995 11.25 11.25 8.8995 11.25 6C11.25 3.10051 8.8995 0.75 6 0.75ZM6 8.25C6.31066 8.25 6.5625 8.50184 6.5625 8.8125C6.5625 9.12316 6.31066 9.375 6 9.375C5.68934 9.375 5.4375 9.12316 5.4375 8.8125C5.4375 8.50191 5.68922 8.25012 5.99978 8.25H6ZM5.78829 2.63728C6.73568 2.52962 7.613 3.1501 7.82711 4.07923C8.04123 5.00836 7.52395 5.95023 6.625 6.26805C6.4751 6.32105 6.37492 6.46281 6.375 6.622V7.125C6.375 7.33211 6.20711 7.5 6 7.5C5.79289 7.5 5.625 7.33211 5.625 7.125V6.6222C5.62475 6.14522 5.92531 5.71994 6.375 5.56095C6.91437 5.37025 7.22474 4.80513 7.09627 4.24765C6.9678 3.69018 6.44141 3.31789 5.87298 3.38248C5.30455 3.44708 4.87511 3.92798 4.875 4.50007C4.87496 4.70718 4.70704 4.87504 4.49993 4.875C4.29282 4.87496 4.12496 4.70704 4.125 4.49993C4.12518 3.54645 4.84091 2.74493 5.78829 2.63728Z"
                fill="white"
            />
        </svg>
    );
}

export default IconHelp;
